import React, { useState, useEffect, useRef } from "react";
import { Col, Row, Button, Form, FormGroup, Label, Input, Container } from "reactstrap";
import SelectBoxSearch from "../../common/SelectBoxSearch";
import SelectBoxSearchAssetItem from "../../common/SelectBoxSearchAssetItem";
import useFormValidation from "../../common/useFormValidation";
import fileSaver from "file-saver";
import api from "../../../apis/api";


const FormAddEditAssetItem = React.memo((props) => {
  const {
    selectedItem,
    selectedAsset,
    userList,
    handleAddAsset,
    handleUpdateAsset,
    assetItemList,
    lastid,
    lastInsertedid,
    path
  } = props;
  var loginUser = JSON.parse(localStorage.getItem("user"));
  const [itemNo, setItemNo] = useState(0);
  const [itemModel, setItemModel] = useState("");
  const [itemUniqueId, setItemUniqueId] = useState("");
  const [itemModelNo, setItemModelNo] = useState("");
  const [itemUser, setItemUser] = useState(0);
  const [warrantyEndDate, setWarrantyEndDate] = useState("");
  const [warrentyFile, setWarrentyFile] = useState("");
  const [purchaseDate, setPurchaseDate] = useState("");
  const [vendor, setVendor] = useState("");
  const [itemId,setItemId]=useState(0);
  const [options,setOptions ]=useState([]);
  const [selectedOption,setSelectedOption]=useState("");
  const [filepath,setfilepath] =useState("");
  const [ItemNumber,setItemNumber]=useState(0);
  const [systemspec, setSystemSpec] = useState("");
  const [comment, setComment] = useState("");
  // for item inside asset.
  const [
    formValidationStateAssetItem,
    setFormValidationStateAssetItem,
  ] = useState({});
  const callValidationAssetItem = useRef(false);

  const { formValidation, isFormValid } = useFormValidation(
    formValidationStateAssetItem
  ); // for item inside asset.
  useEffect(() => {
    // calls when asset item's add&edit form is submited.
    callValidationAssetItem.current && callBackAfterValidationAssetItem();
  }, [formValidation]);

  useEffect(()=>{

    if(assetItemList!=null){
      let empArr = [];
      //only show software Type Assets in Asset Options
      assetItemList.filter(n=>n.itemType == 1).forEach((element) => {
        empArr.push({ value: element, label: element.itemName,itemId:element.itemId });
      });  
      setOptions(empArr);
    }
   
  },[assetItemList])
  // const saveFile = (uploadPolicyFilePath) => {
  //   // let dd=RNFS.DownloadDirectoryPath;
  //   let gg="C:/Nira/EmployeeManagement-API/EmployeeManagement.API/EmployeeManagement.API/EmployeeManagement.API/Resources/Images/image004.jpg";
  //   fileSaver.saveAs(
  //     gg,
  //     "11"
  //   );
  // }
//   const onButtonClick = () => {
//     // const pdfUrl = "C:/Nira/EmployeeManagement-API/EmployeeManagement.API/EmployeeManagement.API/EmployeeManagement.API/Resources/WarrantyFiles/Assets.xlsx";
//     const link = document.createElement("a");
//     link.href = pdfUrl;
//     link.download = "document.pdf"; // specify the filename
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
// };
// const downloadEmployeeData = () => {
//  fileSaver.saveAs(
//       "sample.pdf",
//       "sample"
//     );

  // fetch('http://104.45.207.246:63306/Resources/WarrantyFiles')
  // await api.asset().GetFilePath("sample.pdf")
  //     .then((response) => {
  //         response.blob().then(blob => {
  //             let url = window.URL.createObjectURL(blob);
  //             console.log(url);
  //             let a = document.createElement('a');
  //             a.href=url;
  //             // a.href = "C:\\Nira\\EmployeeManagement-API\\EmployeeManagement.API\\EmployeeManagement.API\\EmployeeManagement.API\\Resources\\WarrantyFiles\\Assets.xlsx";
  //             a.download = 'sample.pdf';
  //             a.click();
  //         });
  //         //window.location.href = response.url;
  //         //http://172.191.196.196/
  // });
// }

  useEffect(() => {
    if (selectedAsset !== "") {
    
      setItemNo(selectedAsset.itemNo);
      setItemModel(selectedAsset.itemModel);
      setItemNumber(selectedAsset.itemNumber);
      setItemUniqueId(selectedAsset.uniqueIdentificationNumber);
      setItemModelNo(selectedAsset.modelNo);
      setVendor(selectedAsset.vendor);
      setPurchaseDate(selectedAsset.purchaseDate.substring(0, 10));
      setWarrantyEndDate(selectedAsset.warrantyEndDate.substring(0, 10));
      let assignedUser = selectedAsset.employeeId == 0 ? 0: (userList?.filter(
        (emp) => emp.value.employeeId === selectedAsset.employeeId
      ));
      setComment(selectedAsset.comment);
      setSystemSpec(selectedAsset.systemSpecs);
      setItemUser(assignedUser?.length >= 0 ? assignedUser[0] : 0); // set user to search select box, took index cuz only one value will be there.
      if(selectedAsset.warrantyFilePath != null)
      {
        const parts = selectedAsset.warrantyFilePath.split('\\');
        const fileNameN = parts[parts.length - 1];
    
        setWarrentyFile(fileNameN);
      }
     

      let empArr = [];
      //only show software Type Assets in Asset Options
      if(assetItemList!=null){
        assetItemList.filter(n=>n.itemId == selectedAsset.itemId).forEach((element) => {
          empArr.push({ value: element, label: element.itemName,itemId:element.itemId });
        });  
      }
      
      setSelectedOption(empArr[0]);
    } else {
      if(parseInt(lastid === '' ? 0 : lastid) !== 0 )
      {
        var arr = lastid.split("-");
        var itemn=parseInt(arr[1]);
        const itemno=arr[0]+"-"+(parseInt(itemn)+1);
        setItemNumber(itemno);
      }
      else
      {
        const part =props.selectedItem.itemName.length >= 2 ? props.selectedItem.itemName.slice(0, 2) :props.selectedItem.itemName.slice(0, 1);
        const itemno=part+"-"+(parseInt(lastInsertedid === '' ? 0 :lastInsertedid)+1);
        setItemNumber(itemno);
      }
    
      setItemNo(0);
      setItemModel("");
      setItemUniqueId("");
      setItemModelNo("");
      setVendor("");
      setItemUser(0);
      setItemId(0);
      setPurchaseDate(
        `${new Date().getFullYear()}-0${new Date().getMonth()}-${new Date().getDate()}`
      );
      setWarrantyEndDate(
        `${new Date().getFullYear()}-0${new Date().getMonth()}-${new Date().getDate()}`
      );
    }
  }, [selectedItem, selectedAsset, userList]);

  // function
  const handleFormSubmit = React.useCallback(() => {

    let AssetFormData = new FormData();
    if(userList!=null || selectedOption==null){
      AssetFormData.append("itemNo", itemNo);
      AssetFormData.append("itemId", props.selectedItem.itemId);
    }
    else{
      AssetFormData.append("itemNo", itemNo);
      AssetFormData.append("itemId",props.selectedItem.itemId);     
    }
    AssetFormData.append("itemNumber",ItemNumber);
    AssetFormData.append("itemModel", itemModel);
    AssetFormData.append("uniqueIdentificationNumber", itemUniqueId);
    AssetFormData.append("modelNo", itemModelNo);
    AssetFormData.append("purchaseDate", purchaseDate);
    AssetFormData.append("vendor", vendor);
    AssetFormData.append("warentyDetails", "");
    AssetFormData.append("warrantyEndDate", warrantyEndDate);
    AssetFormData.append(
      "employeeId",
      itemUser !== 0 ? itemUser.value.employeeId : 0
      // itemUser?.value?.employeeId ?? loginUser.EmployeeId
    );
    AssetFormData.append("WarrantyFileUpload", warrentyFile);
    AssetFormData.append("systemSpecs", systemspec);
    AssetFormData.append("comment", comment);
    if (selectedAsset !== "") {
      handleUpdateAsset(AssetFormData);
    } else {
      handleAddAsset(AssetFormData);
    }
  }, [
    itemModel,
    itemNo,
    itemModelNo,
    itemUniqueId,
    itemUser,
    // props,
    selectedItem,
    handleAddAsset,
    handleUpdateAsset,
    purchaseDate,
    selectedAsset,
    vendor,
    warrantyEndDate,
    warrentyFile,
    selectedOption,
    systemspec,
    comment
  ]);
  // asset item valdation's and ADD&EDIT call.
  const formValidationOnSubmitAddAssetItem = React.useCallback(
    (e) => {
      e.preventDefault();
      let formValidationList = {
        // key name should be same as the input field name to represtent in form.
        itemModel: {
          required: true,
          isValid: true,
          value: itemModel,
          errorMessage: "",
        },
        itemUniqueId: {
          required: true,
          isValid: true,
          value: itemUniqueId,
          errorMessage: "",
        },
      };
      setFormValidationStateAssetItem(formValidationList); //this set call the custom hook useFormValidation.
      callValidationAssetItem.current = true;
    },
    [itemModel, itemUniqueId]
  );

  // asset add after validation.
  const callBackAfterValidationAssetItem = React.useCallback(() => {
    if (isFormValid) {
      // if form valid.
      handleFormSubmit();
    }
  }, [isFormValid, handleFormSubmit]);
  const downloadFile = (fileName) => {
    // Construct the file URL


    const pdfUrl = "/img/employee/"+fileName;
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = fileName; // specify the filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
  return (
    <Container>
    <Form>
    {userList?(
      <Row form>
        <Col md={6}>
          <FormGroup>
            <Label for="exampleEmail">Asset</Label>
            <Input type="text" value={props.selectedItem.itemName} disabled />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="examplePassword">Item No</Label>
            <Input type="text" value={ItemNumber} disabled />
          </FormGroup>
        </Col>
      </Row>    
    ):null} 
      <Row form>
        <Col md={6}>
          <FormGroup>
            <Label for="exampleEmail">Item Model</Label>
            <Input
              type="text"
              placeholder="Enter Item Model"
              value={itemModel}
              onChange={(e) => setItemModel(e.target.value)}
            />
            {
              // Object.keys(formValidation).length !== 0 &&
              !formValidation?.itemModel?.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation?.itemModel?.errorMessage}
                </span>
              )
            }
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="examplePassword">Unique ID</Label>
            <Input
              type="text"
              name="uniquieId"
              placeholder="Enter Unique ID"
              value={itemUniqueId}
              onChange={(e) => setItemUniqueId(e.target.value)}
            />
            {
              // Object.keys(formValidation).length !== 0 &&
              !formValidation?.itemUniqueId?.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation?.itemUniqueId?.errorMessage}
                </span>
              )
            }
          </FormGroup>
        </Col>
      </Row>
      <Row form>
        <Col md={6}>
          <FormGroup>
            <Label for="exampleEmail">Model No</Label>
            <Input
              type="text"
              name="modelNo"
              placeholder="Enter Model No"
              value={itemModelNo}
              onChange={(e) => setItemModelNo(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="examplePassword">Vendor</Label>
            <Input
              type="text"
              value={vendor}
              onChange={(e) => setVendor(e.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row form>
        <Col md={6}>
          <Row>
          {userList?(
            <Col md={6}>
            
              <FormGroup>
                <Label>User</Label>
                <SelectBoxSearch
                  selectedUser={itemUser}
                  options={userList}
                  onChange={(selectedOption) => setItemUser(selectedOption)}
                ></SelectBoxSearch>
              </FormGroup>              
            </Col>
            ):null}
            {assetItemList?(
              <Col md={6}>            
              <FormGroup>
                <Label>Asset</Label>
                <SelectBoxSearchAssetItem
                  selectedItem={selectedOption}
                  options={options}
                  setSelectedOption = {setSelectedOption}
                ></SelectBoxSearchAssetItem>
              </FormGroup>              
              </Col>
            ):null}            
            <Col md={6}>
              <FormGroup>
                <Label for="exampleEmail">Purchase Date</Label>
                <Input
                  type="date"
                  value={purchaseDate}
                  onChange={(e) => setPurchaseDate(e.target.value)}
                />
              </FormGroup>
            </Col>
          </Row>
        </Col>
        <Col md={6}>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="exampleEmail">Warranty End Date</Label>
                <Input
                  type="date"
                  value={warrantyEndDate}
                  onChange={(e) => setWarrantyEndDate(e.target.value)}
                />
              </FormGroup>
            </Col>
           
          </Row>
        </Col>
      </Row>
      <Row>
       <Col md={12}>
<Row>
<Col md={6}>
<FormGroup>
            <Label for="examplePassword">System Specs</Label>
            <Input
              type="textarea"
              value={systemspec}
              onChange={(e) => setSystemSpec(e.target.value)}
            />
          </FormGroup>
</Col>
<Col md={6}>
<FormGroup>
            <Label for="examplePassword">Comment</Label>
            <Input
              type="textarea"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </FormGroup>
</Col>
</Row>
</Col>
       </Row>
<Row>
<Col md={6}>
<Row>
<Col md={6}>
              <FormGroup>
                <Label for="exampleEmail">Warranty File</Label>
                <Input
                  type="file"
                  onChange={(e) => setWarrentyFile(e.target.files[0])}
                />
                {/* <Button onClick={downloadEmployeeData}>Download</Button> */}

              </FormGroup>
            </Col>
            <br/>
            <Col md={6}>
            <FormGroup>
          {warrentyFile != "" ? (<Button onClick={() => downloadFile(warrentyFile)}>Download PDF</Button>) :(null)}  
            </FormGroup>
            </Col>
            </Row>
            </Col>
       </Row>
      
      <Row>
        <Col className="text-center">
          <Button
            type="submit"
            color=""
            className="btn-admin-settings"
            // onClick={handleFormSubmit}
            onClick={formValidationOnSubmitAddAssetItem}
          >
            {selectedAsset !== "" ? "Update" : "Add"}
          </Button>
          &nbsp;
          <Button color="" className="btn-cancel" onClick={props.handleCancel}>
            Cancel
          </Button>
        </Col>
      </Row>
    </Form>
    </Container>
  );
});

export default FormAddEditAssetItem;
